export const PUBLISHED_LOCALE_LOADERS = {
  'ar': () => import('../locales/ar.json'),
  'bg': () => import('../locales/bg.json'),
  'ca': () => import('../locales/ca.json'),
  'cs': () => import('../locales/cs.json'),
  'da': () => import('../locales/da.json'),
  'de': () => import('../locales/de.json'),
  'el': () => import('../locales/el.json'),
  'en-CA': () => import('../locales/en-CA.json'),
  'en-GB': () => import('../locales/en-GB.json'),
  'es-CO': () => import('../locales/es-CO.json'),
  'fa': () => import('../locales/fa.json'),
  'fi': () => import('../locales/fi.json'),
  'fr': () => import('../locales/fr.json'),
  'hr': () => import('../locales/hr.json'),
  'it': () => import('../locales/it.json'),
  'ja': () => import('../locales/ja.json'),
  'ko': () => import('../locales/ko.json'),
  'nl': () => import('../locales/nl.json'),
  'pl': () => import('../locales/pl.json'),
  'pt-BR': () => import('../locales/pt-BR.json'),
  'pt-PT': () => import('../locales/pt-PT.json'),
  'ru': () => import('../locales/ru.json'),
  'sv': () => import('../locales/sv.json'),
  'tr': () => import('../locales/tr.json'),
  'uk': () => import('../locales/uk.json'),
  'vi': () => import('../locales/vi.json'),
  'zh-CN': () => import('../locales/zh-CN.json'),
  'zh-TW': () => import('../locales/zh-TW.json'),
};
